import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="Play">{props.title || 'Play'}</title>
      <g>
        <path d="M255.5,5C116.6,5,4,117.6,4,256.5C4,395.41,116.6,508,255.5,508C394.4,508,507,395.4,507,256.5
	C507,117.6,394.4,5,255.5,5 M374.8,269.99l-172.98,98.6c-13.03,7.44-23.69,1.36-23.69-13.48V157.9c0-14.84,10.66-20.91,23.69-13.49
	L374.8,243C387.8,250.43,387.8,262.57,374.8,269.99" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/play.js